<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        version="1.1"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        width="512"
        height="512"
        x="0"
        y="0"
        viewBox="0 0 24 24"
        style="enable-background: new 0 0 512 512"
        xml:space="preserve"
        class="">
        <g>
            <path
                d="M21.5 0h-14A2.503 2.503 0 0 0 5 2.5V7H0v14c0 1.654 1.346 3 3 3h18c1.654 0 3-1.346 3-3V2.5C24 1.122 22.878 0 21.5 0ZM5 21c0 1.103-.897 2-2 2s-2-.897-2-2V8h4v13Zm18 0c0 1.103-.897 2-2 2H5.234A2.987 2.987 0 0 0 6 21V2.5C6 1.673 6.673 1 7.5 1h14c.827 0 1.5.673 1.5 1.5V21ZM15 7h6v1h-6V7Zm-7 4h13v1H8v-1Zm0 4h13v1H8v-1Zm0 4h13v1H8v-1Zm5-16H8v5h5V3Zm-1 4H9V4h3v3Z"
                fill="currentColor"
                opacity="1"
                data-original="currentColor"
                class=""></path>
        </g>
    </svg>
</template>
